// Sidebar layout entry for the Orders module.
// 2026-04-05 - Added permissions enforcement (BUG-007): viewOrders (OR001) required to see menu item.
import paths from './paths';
import permissions from './permissions';
import * as screens from '@core/layouts/components/menu/screens';

export default [
  {
    id: 'ordersPool',
    title: 'orders.pool',
    iconName: 'Package',
    permissions: [permissions.viewOrders],
    navLink: paths.pool,
    screenId: screens.ORDERS_POOL
  }
];
